import { render, staticRenderFns } from "./NewReservationsVentrata.vue?vue&type=template&id=520a04c8"
import script from "./NewReservationsVentrata.vue?vue&type=script&lang=js"
export * from "./NewReservationsVentrata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports